<template>
    <div class="system-message" :class="{'custom': isCustomText(), 'started': isRoundStart()}">
        <div class="system-text" :class="{'started': isRoundStart(), 'ended': isRoundEnd()}">
            <template v-if="isRoundStart()">
                <span class="chat-title">{{ message.data.data.params.text }}</span>
            </template>

            <template v-if="isRoundEnd()">
                <template v-if="message.data.data && message.data.data.params.text">{{ message.data.data.params.text }}</template>
                <template v-if="message.data.data && message.data.data.time_is_up">{{$t('message.time_is_up')}}! </template>
                <div class="chat-title" :class="{'pb-0': hasCaption()}">{{$t('message.round_is_over')}}!</div>
            </template>

            <template v-if="isGameStart()">
                {{$t('message.game')}} {{$t('message.begins')}}!
            </template>

            <template v-if="isGameEnd()">
                <div class="chat-title">{{$t('message.game_has_ended')}}</div>
            </template>

            <template v-if="isTimerEnded()">
                <span class="important-text">{{getTimeString(message.data.data.params.seconds)}} {{$t('message.expired')}}</span>
            </template>

            <template v-if="isCustomText()">
                <span class="important-text">{{message.data.data.params.text}}</span>
            </template>
            <template v-if="hasCaption()">
                <span class="chat-title__caption" :class="{'pt-0': isRoundEnd() && !isCustomText()}">{{message.data.data.params.caption}}</span>
            </template>
        </div>
    </div>
</template>

<script>

const MESSAGE_ROUND_START = 1;
const MESSAGE_ROUND_END = 2;
const MESSAGE_GAME_START = 3;
const MESSAGE_GAME_END = 4;
const MESSAGE_TIMER_ENDED = 5;
const MESSAGE_CUSTOM_TEXT = 6;

export default {
    props: {
        message: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            MESSAGE_ROUND_START: MESSAGE_ROUND_START,
            MESSAGE_ROUND_END: MESSAGE_ROUND_END,
            MESSAGE_GAME_START: MESSAGE_GAME_START,
            MESSAGE_GAME_END: MESSAGE_GAME_END,
            MESSAGE_TIMER_ENDED: MESSAGE_TIMER_ENDED,
            MESSAGE_CUSTOM_TEXT: MESSAGE_CUSTOM_TEXT,
        }
    },

    methods: {
        /**
         * Тип - начало раунда
         */
        isRoundStart()
        {
            return this.message.data.action === this.MESSAGE_ROUND_START;
        },

        /**
         * Тип - конец раунда
         */
        isRoundEnd()
        {
            return this.message.data.action === this.MESSAGE_ROUND_END;
        },

        /**
         * Тип - игра началась
         */
        isGameStart()
        {
            return this.message.data.action === this.MESSAGE_GAME_START;
        },

        /**
         * Тип - игра закончилась
         */
        isGameEnd()
        {
            return this.message.data.action === this.MESSAGE_GAME_END;
        },

        /**
         * Тип - таймер закончился
         */
        isTimerEnded()
        {
            return this.message.data.action === this.MESSAGE_TIMER_ENDED;
        },

        /**
         * Кастомный текст
         */
        isCustomText()
        {
            return this.message.data.action === this.MESSAGE_CUSTOM_TEXT && this.message.data.data.params.text;
        },

        /**
         * Имеет подпись
         */
        hasCaption()
        {
            return this.message.data.data && this.message.data.data.params.caption;
        },

        /**
         * Форматированное кол-во секунд
         */
        getTimeString(seconds)
        {
            if (!seconds) {
                return '';
            }

            let result = '';

            const min = Math.floor(seconds / 60);
            if (min > 0) {
                result += min + ' ' + this.$t('common.min') + ' ';
            }

            const sec = seconds% 60;
            if (sec > 0) {
                result += sec + ' ' + this.$t('common.sec');
            }

            return result;
        },
    }
}
</script>

<style scoped>
    .caption {
        display: block;
        margin-top: 5px;
    }
</style>
